export const addCustomerTransaction = async (transactionData) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "addCustomerTransactions", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, ...transactionData})
    });
    const jsonResponse = await response.json();
    if (jsonResponse?.success === true) {
        let data = transactionData;
        data.id = jsonResponse?.data?.id;
        jsonResponse.data = data;
    }
    console.log('Add Customer Transaction Response:', response);
    return jsonResponse;
};
export const updateCustomerTransaction = async (transactionId, transactionData) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "updateCustomerTransactions", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, id: transactionId, ...transactionData})
    });
    const jsonResponse = await response.json();
    if (jsonResponse?.success === true) {
        let data = transactionData;
        data.id = transactionId;
        jsonResponse.data = data;
    }
    console.log('Update Customer Transaction Response:', response);
    return jsonResponse;
};
export const deleteCustomerTransaction = async (transactionId) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "deleteCustomerTransactions", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, id: transactionId})
    });
    return await response.json();
};
export const addCustomerTransactionAndUpdateStock = async (transactionData, stockItems) => {
  try {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({
            action: "addCustomerTransactionAndUpdateStock",
            transaction: transactionData,
            stockItems: stockItems || [],
            apiKey: process.env.REACT_APP_API_KEY,
            origin: window.location.origin
        })
    });
    const jsonResponse = await response.json();
    console.log(jsonResponse);
    if (jsonResponse.success === true) {
      let data = transactionData;
      data.id = jsonResponse?.data?.transactionId;
      data.customerUpdate = jsonResponse?.data?.customerUpdate;
      return {success:true, data}
    }
  } catch (error) {
    console.error("API error in addCustomerTransactionAndUpdateStock:", error);
    return {
      success: false,
      error: error.message,
      message: "Failed to add transaction and update stock"
    };
  }
};
export const removeCustomerTransactionAndUpdateStockApi = async (data) => {
  try {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({
            action: "removeCustomerTransactionAndUpdateStock",
            apiKey: process.env.REACT_APP_API_KEY,
            origin: window.location.origin,
            ...data
        })
    });
    const jsonResponse = await response.json();
    console.log(jsonResponse);
    if (jsonResponse.success === true) {
        let responseData = jsonResponse?.data
      return {success:true, data: responseData}
    }
  } catch (error) {
    console.error("API error in removeCustomerTransactionAndUpdateStock:", error);
    return {
      success: false,
      error: error.message,
      message: "Failed to remove transaction and update stock"
    };
  }
};